<template>
 <svg :style="style" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="&#229;&#164;&#167;&#229;&#176;&#143;&#231;&#177;&#187;&#229;&#158;&#139;=&#229;&#164;&#167;40, &#231;&#167;&#145;&#229;&#174;&#164;&#229;&#144;&#141;&#231;&#167;&#176;=&#228;&#185;&#179;&#232;&#133;&#186;&#229;&#164;&#150;&#231;&#167;&#145;">
<g id="Frame" clip-path="url(#clip0_3618_71526)">
<path id="Vector" d="M30.7592 4.65918C28.2403 4.65918 27.7584 6.73447 26.7444 9.67387C25.7767 12.4785 23.9715 15.4189 21.3701 17.3624C21.2796 15.1096 20.6946 5.75617 20.682 5.5575C20.6519 5.09124 20.4104 4.73714 20.0241 4.73714C19.6062 4.73714 19.3813 5.15562 19.3637 5.5575C19.3552 5.76271 18.8019 15.0457 18.6726 17.3624C16.4907 15.5738 14.1177 12.994 12.9462 9.67387C12.0761 7.20777 10.6134 4.65918 8.73077 4.65918C5.54642 4.65918 3.63762 16.7533 4.0576 21.9133C4.41572 26.3084 8.15235 32.3003 13.4125 32.3003C16.0672 32.3003 18.0389 30.9468 18.8939 29.0129C19.2722 28.1568 20.762 27.8822 21.355 29.0129C22.4238 31.0504 24.4016 32.2319 27.093 32.3003C30.6873 32.3904 36.0545 26.9728 36.0032 21.9636C35.9077 12.6389 34.2639 4.65918 30.7592 4.65918Z" fill="white"/>
</g>
</g>
<defs>
<clipPath id="clip0_3618_71526">
<rect width="32" height="32" fill="white" transform="translate(4 4)"/>
</clipPath>
</defs>
</svg>




</template>

<script>
export default {
  name: 'icon-yxwk',
  props: {
    fontSize: {
      type: String,
      default: '18px'
    },
    color: {
      type: String,
      default: 'white'
    }
  },
  data() {
    return {
      style: {
        width: '1em',
        height: '1em',
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
        cursor: 'pointer',
        'font-size': this.fontSize
      }
    }
  }
}
</script>